import React from 'react'
import PropTypes from 'prop-types'
import { Separator, Row, H1, Overline, Subheading, Paragraph, useContainerWidth, MoreLess } from '@fs/zion-ui'
import { SectionDescription } from '../section-card'
import { MonoText } from '../type'
import RainbowText from '../RainbowText'

export default function PageHeading({
  heading,
  subHeading,
  description,
  overline,
  fullWidth,
  bold,
  centered,
  dataTestId,
  children,
  action,
  flavor,
  size = 'H1',
  supplementary,
  isCleanDescription,
  'data-testid': testId,
}) {
  const atWidth = useContainerWidth()
  const formattedHeading = bold ? <strong>{heading}</strong> : heading
  return heading ? (
    <>
      <H1 data-testid={testId} size={size} centered={centered} supplementary={supplementary}>
        {overline && (
          <Overline>
            <Paragraph size={atWidth({ default: 'sm', lg: 'md' })} centered={centered}>
              {overline}
            </Paragraph>
          </Overline>
        )}
        {flavor !== 'none' ? (
          <RainbowText flavor={flavor}>{formattedHeading}</RainbowText>
        ) : (
          <MonoText>{formattedHeading}</MonoText>
        )}
        {subHeading && (
          <>
            <Separator size="xxs" />
            <Subheading>{subHeading}</Subheading>
          </>
        )}
      </H1>
      {description && (
        <>
          <Separator size="xxs" />
          <MoreLess collapsedLineCount={4} buttonProps={{ centered: true }}>
            <SectionDescription
              isClean={isCleanDescription}
              fullWidth={fullWidth}
              bold={bold}
              centered={centered}
              dataTestId={dataTestId}
            >
              {description}
            </SectionDescription>
          </MoreLess>
        </>
      )}
      {action && <Separator size="sm" />}
      {action && <Row alignX={centered ? 'center' : 'start'}>{action}</Row>}
      {action && <Separator size="sm" />}
      {children}
    </>
  ) : null
}

PageHeading.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}
